import React from 'react'

const Transactions = () => {
  return (
    <div>
      <img src="https://custom-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/8103728/142995_42655.png" alt="" />
    </div>
  )
}

export default Transactions